import ui from './QuestionMark.module.css'

export function QuestionMark() {
  return <span class={ui.questionMark}>?</span>
}
